// extracted by css-extract-rspack-plugin
export default {"root":"gU7aEI_MgEnSbZHo","link":"qMBMVSMrvQYt0LUw"};